module.exports = __webpack_public_path__ + "img/pk_urd.c4596cf2.png";